import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: '',
    chotag: [],
    phone: '',
    bank: '',
    branch: '',
    code: ''
  },
  modules: {},
  getters: {},
  mutations: {
    SET_BANK: (state, bank) => {
      state.bank = bank
    },
    SET_BRANCH: (state, branch, ) => {
      state.branch = branch
    },
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_TAG: (state, tag) => {
      state.chotag = tag
    },
    SET_PHONE: (state, p) => {
      state.phone = p
    }
  },
  actions: {}
})

export default store